import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"

import { cn } from "../lib/utils"

// Date-style input types that Chrome/Edge render with a calendar widget. When
// the OS is set to Thai + Buddhist era, those browsers return the `value`
// with a BE year ("2569-04-24T09:00") — a known Chromium bug (crbug.com/763760
// and crbug.com/818403). Forcing `lang="en-GB"` pins the widget to Gregorian
// and DD/MM/YYYY display, which bypasses the bug at the source.
const CALENDAR_INPUT_TYPES = new Set([
  "date",
  "datetime-local",
  "month",
  "time",
  "week",
])

function Input({ className, type, lang, ...props }: React.ComponentProps<"input">) {
  const shouldForceGregorian = type && CALENDAR_INPUT_TYPES.has(type)
  const effectiveLang = shouldForceGregorian ? (lang ?? "en-GB") : lang
  return (
    <InputPrimitive
      type={type}
      lang={effectiveLang}
      data-slot="input"
      className={cn(
        "h-8 w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-0 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50",
        className
      )}
      {...props}
    />
  )
}

export { Input }
